import type {
  AddParameterWindowProps,
  PlotParameterType,
} from "@/overlay/components/AddParameterWindow/AddParameterWindow";
import { highchartsIconSeriesTypes } from "@/overlay/components/CommonParts/PlotHighchart/utils/chart-options/iconSeriesType";
import type { AppDispatch } from "@/reducer";
import { addPlotSerie } from "@/reducer/PlotsState";
import {
  DefaultPlotSeries,
  type Plot,
  type PlotSeriesType,
  type PortfolioEnergyPlotSeries,
  StartColor,
} from "@/reducer/client-models";
import { highchartsColors } from "@/utility/highchartsValues";
import { getDefaultModelName } from "@/utility/layer";
import type { HasLayerIdxNarrowing, PartialWeatherParameter } from "@mm/weather-parameter-utils";
import * as weatherParameter from "@mm/weather-parameter-utils";

export function createPlotAddParameterWindowProps(
  plot: Plot,
  dispatch: AppDispatch,
): Pick<AddParameterWindowProps, "source" | "onSubmitParam" | "onSubmitPortfolioEnergy"> {
  return {
    source: "add-plot-param",
    onSubmitParam: (
      parameter: HasLayerIdxNarrowing<PartialWeatherParameter>,
      parameterType: PlotParameterType,
      model: string | null,
    ) => {
      const parameterString = weatherParameter.parameterToString(parameter);
      const index = plot.plotSeries.length;
      const seriesColor = highchartsColors ? highchartsColors[index % highchartsColors.length].toString() : StartColor;
      const serie: PlotSeriesType = {
        ...DefaultPlotSeries,
        index,
        parameter_unit: parameterString.formatted,
        model: model || getDefaultModelName(parameter),
        series_color: seriesColor,
        visible: true,
      };

      if (highchartsIconSeriesTypes.includes(parameterType)) {
        serie.series_type = parameterType;
      }

      dispatch(addPlotSerie({ plotId: plot.id, serie }));
    },
    onSubmitPortfolioEnergy: (portfolioEnergy: PortfolioEnergyPlotSeries["portfolioEnergy"]) => {
      const index = plot.plotSeries.length;
      dispatch(
        addPlotSerie({
          plotId: plot.id,
          serie: {
            source: "portfolio-energy",
            series_type: "portfolio-energy",
            index,
            series_color: highchartsColors[index % highchartsColors.length].toString(),
            series_line_type: "Solid",
            series_y_axis: 0,
            visible: true,
            portfolioEnergy,
          },
        }),
      );
    },
  };
}
